import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Enumerable from 'linq';
import { ConferenceViewModelWithDetails, SponsorshipProductViewModel } from 'src/app/_models/generatedModels';
import { CallForSponsorsService, ConferenceCMSService, OrganizationService } from 'src/app/_services/generatedServices';
import { SponsorshipCartService } from 'src/app/_services/sponsorship-cart.service';
import { BoothPickerComponent } from './booth-picker.component';

@Component({
  selector: 'bxl-view-cart',
  templateUrl: 'view-cart.component.html',
})
export class ViewCartComponent implements OnInit {
  initialized = false;
  conferenceId: string;
  homeRoute: string;
  conference: ConferenceViewModelWithDetails;
  constructor(public cart: SponsorshipCartService, private cmsService: ConferenceCMSService, private modalService: NgbModal, private orgService: OrganizationService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.conferenceId = params.get('conferenceSlug');
      this.cart.checkCart(this.conferenceId);
      this.cmsService.getWebsitePagesForConference(this.conferenceId).subscribe((pages) => {
        this.orgService.getConferenceBySlug(this.conferenceId).subscribe((conference) => {
          this.conference = conference;
          var page = Enumerable.from(pages)
            .where((x) => x.elements.find((x) => x.pageElementType.toString() == 'ProductListing') != null)
            .firstOrDefault();
          this.homeRoute = page.slug;
          this.initialized = true;
        });
      });
    });
  }

  editOnMap(product: SponsorshipProductViewModel) {
    const modalRef = this.modalService.open(BoothPickerComponent, { size: 'lg', windowClass: 'fullscreen', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.componentInstance.conferenceId = this.conferenceId;
    modalRef.componentInstance.product = product;
    console.log(product);
    modalRef.componentInstance.boothIdsFromCart = Enumerable.from(this.cart.items)
      .where((x) => x.product.id == product.id)
      .select((x) => x.variationId)
      .toArray();

    console.log(modalRef.componentInstance.boothIdsFromCart);
  }
}
